import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { 
  Home, Users, Grid, UserCheck, HelpCircle, Menu, 
  LogOut, FileText, FolderPlus 
} from "react-feather";
import logo from "../img/logoa.jpeg";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";

const NavItem = ({ to, icon: Icon, label, isActive }) => (
  <Link to={to} className={`kp ${isActive ? "active" : ""}`} style={{ textDecoration: "none" }}>
    <li className={`kp ${isActive ? "active" : ""}`}>
      <Icon className="ic" />
      <span>{label}</span>
    </li>
  </Link>
);

const AdminSidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState(null);
  const [modules, setModules] = useState([]);

useEffect(() => {
    const adminId = localStorage.getItem("admin_id");
    if (adminId) {
      fetch(`${baseurl}FetchAdminDataById/${adminId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.admin) {
            setAdminData(data.admin);
            
            // Parse the JSON strings from the array into actual JS objects
            const parsed = (data.admin.modules || []).map((modStr) => {
              try {
                return typeof modStr === "string" ? JSON.parse(modStr) : modStr;
              } catch (e) {
                console.error("Failed to parse module:", modStr);
                return null;
              }
            }).filter(Boolean); // Remove any null values if parsing failed
            
            setModules(parsed);
          }
        })
        .catch((error) => console.error("Error fetching admin data:", error));
    }
  }, []);

  // hasModule now safely checks the 'id' property of your objects
  const hasModule = useMemo(() => (id) => modules.some((m) => m.id === id), [modules]);

  // const hasModule = useMemo(() => (id) => modules.some((m) => m.id === id), [modules]);
  const isActive = (path) => pathname === path;

  const handleLogout = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to log out.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, log out",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        navigate("/admin/login");
      }
    });
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="text-dark d-flex align-items-center">
          <img src={logo} className="img-fluid logoadmin" alt="Logo" />&nbsp;
          <span className="kal11">Tech Spares</span>
        </div>
      </div>

      <ul className="sidebar-menu">
        {/* MODULE 1: Dashboard & Core */}
        {hasModule(1) && (
          <>
            <NavItem to="/admin/dashboard" icon={Home} label="Dashboard" isActive={isActive("/admin/dashboard")} />
            <NavItem to="/admin/seller-list-cost" icon={Home} label="Seller List/ cost" isActive={isActive("/admin/seller-list-cost")} />
            <NavItem to="/admin/review" icon={Home} label="Listing Reviews" isActive={isActive("/admin/review")} />
            <NavItem to="/admin/direct-purchase" icon={HelpCircle} label="Direct Purchase (Admin)" isActive={isActive("/admin/direct-purchase")} />
            <NavItem to="/admin/all-enquiry" icon={UserCheck} label="Product Enquiry (Admin)" isActive={isActive("/admin/all-enquiry")} />
            <NavItem to="/admin/contact" icon={FolderPlus} label="Contact Forms" isActive={isActive("/admin/contact")} />
            <NavItem to="/admin/seller-quote" icon={FolderPlus} label="Request Quotes (Seller)" isActive={isActive("/admin/seller-quote")} />
          </>
        )}

        {/* MODULE 2: Website Management */}
        {hasModule(2) && (
          <>
            <div className="liname my-2">Website Management</div>
            <NavItem to="/admin/item-category" icon={HelpCircle} label="Category Builder" isActive={isActive("/admin/item-category")} />
            <NavItem to="/admin/all-category" icon={HelpCircle} label="All Category" isActive={isActive("/admin/all-category")} />
            <NavItem to="/admin/all-trash-category" icon={HelpCircle} label="All Trash Category" isActive={isActive("/admin/all-trash-category")} />
            <NavItem to="/admin/all-service-category" icon={HelpCircle} label="Service Category" isActive={isActive("/admin/all-service-category")} />
            <NavItem to="/admin/all-service-request" icon={HelpCircle} label="All Service Requests" isActive={isActive("/admin/all-service-request")} />
            <NavItem to="/admin/full-banner" icon={HelpCircle} label="Website Banner" isActive={isActive("/admin/banner")} />
            <NavItem to="/admin/all-coupon" icon={UserCheck} label="Discount Coupon" isActive={isActive("/admin/all-coupon")} />
            <NavItem to="/admin/approve-listing" icon={UserCheck} label="Approve Listing" isActive={isActive("/admin/approve-listing")} />
            <NavItem to="/admin/all-approved-listing" icon={UserCheck} label="All Approved Listing" isActive={isActive("/admin/all-approved-listing")} />
            <NavItem to="/admin/all-rejected-listing" icon={UserCheck} label="All Rejcted Listing" isActive={isActive("/admin/all-rejected-listing")} />
            <NavItem to="/admin/download" icon={UserCheck} label="Download Listings" isActive={isActive("/admin/download")} />
          </>
        )}

        {/* MODULE 3: Report & Education */}
        {hasModule(3) && (
          <>
            <div className="liname my-2">Report Management</div>
            <NavItem to="/admin/seller-report" icon={HelpCircle} label="Reports" isActive={isActive("/admin/seller-report")} />
            <NavItem to="/admin/all-sellers" icon={HelpCircle} label="Sellers" isActive={isActive("/admin/all-sellers")} />
            <NavItem to="/admin/all-customer" icon={HelpCircle} label="Customers" isActive={isActive("/admin/all-customer")} />
            <NavItem to="/admin/all-listings" icon={HelpCircle} label="All Listing" isActive={isActive("/admin/all-listings")} />

            <div className="liname my-2">Education Management</div>
            <NavItem to="/admin/education-category" icon={HelpCircle} label="Education Category" isActive={isActive("/admin/education-category")} />
            <NavItem to="/admin/add-education" icon={HelpCircle} label="Add Education" isActive={isActive("/admin/add-education")} />
            <NavItem to="/admin/all-education" icon={HelpCircle} label="All Education" isActive={isActive("/admin/all-education")} />
          </>
        )}

        {/* Blog Management */}
        {hasModule(5) && (
          <>
           <div className="liname my-2">Blog Management</div>
        <NavItem to="/admin/add-blog-category" icon={HelpCircle} label="Blog Category" isActive={isActive("/admin/add-blog-category")} />
        <NavItem to="/admin/add-blog" icon={HelpCircle} label="Create Blog" isActive={isActive("/admin/add-blog")} />
        <NavItem to="/admin/blog-list" icon={HelpCircle} label="All Blog" isActive={isActive("/admin/blog-list")} />
</>
        )}
        
        {/* MODULE 4: Orders */}
        {hasModule(4) && (
          <>
            <div className="liname my-2">Orders Management</div>
            <NavItem to="/admin/all-orders" icon={Menu} label="All Orders" isActive={isActive("/admin/all-orders")} />
            <NavItem to="/admin/ship-to" icon={Menu} label="All Ship To List" isActive={isActive("/admin/ship-to")} />
          </>
        )}

        {/* SUPER ADMIN SECTIONS */}
        {adminData?.role === "super-admin" && (
          <>
            <div className="liname my-2">Add Admins</div>
            <NavItem to="/add-admin" icon={Grid} label="Add Admin" isActive={isActive("/add-admin")} />

            <div className="liname my-2">Website Settings</div>
            <NavItem to="/admin/footer-details" icon={FolderPlus} label="Website Details" isActive={isActive("/admin/footer-details")} />
            <NavItem to="/admin/terms-condition" icon={FolderPlus} label="Terms & Condition" isActive={isActive("/admin/terms-condition")} />
            <NavItem to="/admin/add-privacy" icon={FileText} label="Privacy Policy" isActive={isActive("/admin/add-privacy")} />
            <NavItem to="/admin/add-shipping-policy" icon={FileText} label="Shipping Policy" isActive={isActive("/admin/add-shipping-policy")} />
            <NavItem to="/admin/add-return-policy" icon={FileText} label="Return/Cancellation Policy" isActive={isActive("/admin/add-return-policy")} />
            <NavItem to="/admin/add-legal-notice" icon={FileText} label="Legal Notice" isActive={isActive("/admin/add-legal-notice")} />
            <NavItem to="/admin/add-about-us" icon={FileText} label="About Us" isActive={isActive("/admin/add-about-us")} />
            <NavItem to="/admin/add-country" icon={FolderPlus} label="Add Country" isActive={isActive("/admin/add-country")} />
            <NavItem to="/admin/add-state" icon={FolderPlus} label="Add State" isActive={isActive("/admin/add-state")} />
            <NavItem to="/admin/all-customer-otp" icon={FolderPlus} label="Otp's" isActive={isActive("/admin/all-customer-otp")} />
            <NavItem to="/admin/installation" icon={FolderPlus} label="Add Installation" isActive={isActive("/admin/installation")} />
            <NavItem to="/admin/setting" icon={FolderPlus} label="Settings" isActive={isActive("/admin/setting")} />
            <NavItem to="/admin/add-terms-seller" icon={FolderPlus} label="Add Terms For Seller" isActive={isActive("/admin/add-terms-seller")} />
            <NavItem to="/admin/testimonial" icon={FolderPlus} label="Testimonial" isActive={isActive("/admin/testimonial")} />
          </>
        )}

        <div className="liname my-2">Logout</div>
        <li className="kp" onClick={handleLogout} style={{ cursor: "pointer" }}>
          <LogOut className="ic" />
          <span>Logout</span>
        </li>
      </ul>
    </div>
  );
};

export default AdminSidebar;